export const getCleanDomain = (domainName) => (domainName.toString().trim().toLowerCase()).replace("http://", "").replace("https://", "")